import { isNil } from '@pct-ts/typeguard';

export function isInstalledPWA(): boolean {
  const isStandaloneDisplayMode = window.matchMedia('(display-mode: standalone)').matches;

  const nav = typeof navigator !== 'undefined' ? (navigator as any) : undefined;
  // Safari support
  const isIosStandalone =
    !isNil(nav) && 'standalone' in nav && !isNil(nav.standalone) && nav.standalone === true;

  return isStandaloneDisplayMode || isIosStandalone;
}
